import { render, staticRenderFns } from "./upload-form-items.vue?vue&type=template&id=379a1a58&scoped=true"
import script from "./upload-form-items.vue?vue&type=script&setup=true&lang=js"
export * from "./upload-form-items.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379a1a58",
  null
  
)

export default component.exports